import {
  Component,
  OnInit,
  ChangeDetectorRef,
  AfterViewInit
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { RequestModel } from 'src/app/shopping-cart/request-model.model';
import { ShoppingCartService } from 'src/app/shopping-cart/shopping-cart.service';
import { fileValidator } from 'src/app/validators/file-validator';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { stateValidator } from 'src/app/validators/state-validator';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { TrimFormControl } from '../trim-control';
import { TouchFormControl } from 'src/app/validation-banner/touch-form-control.modal';
import { MaintenanceService } from 'src/app/maint-service/maintenance.service';
import { ProviderTypeService } from 'src/app/prov-service/provider-type.service';
import { RequestTypeService } from 'src/app/req-type/request-type.service';
import { KeyValue } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal/';
import { EventService } from 'src/app/main/event-service/event.service';
import { State } from '../state.model';

@Component({
  selector: 'app-group-maintenance',
  templateUrl: './group-maintenance.component.html',
  styleUrls: ['../../app.component.scss']
})
export class GroupMaintenanceComponent implements OnInit, AfterViewInit {
  colorTheme = 'theme-dark-blue';
  bsConfig: Partial<BsDatepickerConfig>;
  private _myForm: FormGroup;
  private _doc: File;
  private _index = null;
  private _request: RequestModel;
  private _duplicated: RequestModel = null;
  private _optDocs: File[] = [];
  private _emitRequest: RequestModel;
  private _showBanner = false;
  public readonly TAXCHANGE = 'TAX CHANGE';
  public faCalendar = faCalendar;
  private readonly _GROUP: boolean = true;
  private _todayDate = new Date();
  private _reqToggle = 'new';

  constructor(
    private cartService: ShoppingCartService,
    private ref: ChangeDetectorRef,
    private maintenanceService: MaintenanceService,
    private providerService: ProviderTypeService,
    private requestTypeService: RequestTypeService,
    private modalService: BsModalService,
    private eventService: EventService
  ) {}

  ngAfterViewInit(): void {
    this._myForm.controls['maintenanceType'].setValue(
      this._request
        ? this._request.maintenanceType
        : this._duplicated
        ? this._duplicated.maintenanceType
        : ''
    );
    this.reqToggle = this.index != null ? 'update' : 'new';
    this.ref.detectChanges();
  }

  ngOnInit() {
    this._myForm = new FormGroup({
      name: new TrimFormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9\&\-\,\.\/\:\#\'\(\) ]+$/)
      ]),
      idType: new TouchFormControl('NPI', [Validators.required]),
      NPI: new TrimFormControl('', [Validators.required]),
      taxID: new TrimFormControl('', []),
      providerID: new TrimFormControl('', []),
      country: new TouchFormControl('US', [Validators.required]),
      requestDetails: new TrimFormControl('', [Validators.required]),
      doc: new TouchFormControl('', []),
      maintenanceType: new TrimFormControl('', [Validators.required]),
      effDate: new TouchFormControl('', [Validators.required]),
      providerType: new TouchFormControl(''),
      requestType: new TouchFormControl(''),
      optDoc: new TouchFormControl('')
    });

    this.bsConfig = Object.assign({}, { containerClass: this.colorTheme });

    this.index = this.eventService.request;
    this.request = this.cartService.getSingleRequest(this.index);
    this.duplicated = this.eventService.requestModel;

    if (this.index !== null && this.myForm.controls['country'].value === 'US') {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
      this.optDocs = this.request.optDocs;
    }
    else if (this.duplicated !== null && this.myForm.controls['country'].value === 'US') {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
    }
    else {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
    }
  }

  public updateFile(doc: any): void {
    this._doc = doc;
  }

  public updateOptFile(docs: any): void {
    if (docs) {
      this.optDocs = docs;
    }
  }

  public updateRequest(emitRequest: RequestModel) {
    this._emitRequest = emitRequest;
  }

  valueAscOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return a.value.localeCompare(b.value);
  }

  public closeParent(close?: any): void {
    this.modalService._hideModal();
    this.modalService._hideBackdrop();
    
    let valid = true;

    if (close !== undefined) {
      valid = close;
    }

    this.eventService.confirmEvent.emit(new State(true, valid, this.reqToggle));
  }

  public submit(event: any): void {
    if (this.submittable()) {
      const request = this._myForm.value;
      const type = 'P01';
      request.providerType = this.providerService.provider[type];
      const reqType = 'R01';
      request.requestType = this.requestTypeService.reqType[reqType];
      request.fileType = this._doc ? this._doc.type : '';
      request.doc = this.doc;
      request.optDocs = this.optDocs;

      if (this.emitRequest) {
        request.state = this._emitRequest.state;
        request.gateway = this._emitRequest.gateway
          ? this._emitRequest.gateway
          : false;
      }
      else {
        request.state = null;
        request.gateway = false;
      }

      this._showBanner = false;
      this.closeParent();
      this.request
        ? this.cartService.editRequest(this.index, request)
        : this.cartService.addToCart(request);
    }
    else if (this._myForm.invalid) {
      this._showBanner = true;
    }
  }

  public submittable(): boolean {
    return this.myForm.touched && this.myForm.valid;
  }

  public handleTypeChange(event): void {
    if (this._myForm.controls['maintenanceType'].value === this.TAXCHANGE) {
      this._myForm.controls['doc'].setValidators([
        Validators.required,
        fileValidator()
      ]);
      this._myForm.controls['doc'].updateValueAndValidity();
    }
    else {
      this._myForm.controls['doc'].setValue('');
      this._doc = null;
      this._myForm.controls['doc'].clearValidators();
      this._myForm.controls['doc'].updateValueAndValidity();
    }
  }

  public filter(): any {
    const arr = Object.keys(this.maintenance)
      .map(key => this.maintenance[key])
      .filter(k => k !== 'LICENSE CHANGE');
    arr.splice(
      arr.indexOf('ADD PARTICIPATION (TO NETWORK)'),
      1,
      'Add Participation'
    );
    return arr;
  }

  public get maintenance() {
    return this.maintenanceService.maintenance;
  }

  public get GROUP(): boolean {
    return this._GROUP;
  }

  public get duplicated(): RequestModel {
    return this._duplicated;
  }

  public set duplicated(request: RequestModel) {
    this._duplicated = request;
  }

  public get todayDate(): Date {
    return this._todayDate;
  }

  public set request(request: RequestModel) {
    this._request = request;
  }

  public get request(): RequestModel {
    return this._request;
  }

  public get myForm(): FormGroup {
    return this._myForm;
  }

  public set myForm(myForm: FormGroup) {
    this._myForm = myForm;
  }

  public get index() {
    return this._index;
  }

  public set index(index: number) {
    this._index = index;
  }

  public get doc(): File {
    return this._doc;
  }

  public set doc(doc: File) {
    this._doc = doc;
  }

  public get reqToggle() {
    return this._reqToggle;
  }

  public set reqToggle(reqToggle: string) {
    this._reqToggle = reqToggle;
  }

  public get emitRequest(): RequestModel {
    return this._emitRequest;
  }

  public set emitRequest(value: RequestModel) {
    this._emitRequest = value;
  }

  public get optDocs(): File[] {
    return this._optDocs;
  }
  
  public set optDocs(value: File[]) {
    this._optDocs = value;
  }

  public get showBanner(): boolean {
    return this._showBanner && this._myForm.touched && !this._myForm.valid;
  }
}
